import cn from "classnames";
import styles from "./SubMenuTitleItem.module.scss";

export const getClassNames = (className?: string) => {
  return cn(styles.title, className);
};